module.exports = __webpack_public_path__ + "media/images/javascript-white-1a1d5df11b3bdc7f7cca8481a323903c.png";